// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1cdrf","boxTitle":"Qualiphy_boxTitle__3TY_h","box":"Qualiphy_box__1Lvsd","toggleWrap":"Qualiphy_toggleWrap__AVMNz"};